import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "PlaybackPrevious.svg",
  "use": "PlaybackPrevious.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"PlaybackPrevious.svg\"><path d=\"M51.022,44.7359,34.0235,34.419v8.5233a1.9967,1.9967,0,0,1-3.0014,1.7936L14.01,34.4112v8.61a2,2,0,0,1-4,0v-22a2,2,0,0,1,4,0v8.6115L31.0221,19.3075a1.9968,1.9968,0,0,1,3.0014,1.7938v8.5231L51.022,19.3075a1.9969,1.9969,0,0,1,3.0015,1.7938v21.841A1.9967,1.9967,0,0,1,51.022,44.7359Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol